// extracted by mini-css-extract-plugin
export default {"paperContainer":"style_paperContainer__3yJ7L","mainContainer":"style_mainContainer__PFdJm","bajaTxt":"style_bajaTxt__96CTM"};